import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { AUDIT_ACTION_LABELS } from '../auditActionLabels';

const selectSx = {
  height: '40px',
  borderRadius: '8px',
  fontSize: '0.875rem',
  minWidth: 200,
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E0E0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
};

const textSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#fff',
    height: '40px',
    '& fieldset': { borderColor: '#E0E0E0' },
    '&:hover fieldset': { borderColor: '#BDBDBD' },
    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
  },
  '& input': { fontSize: '0.875rem' },
};

/**
 * CompanyAuditFilters - Barra de filtros da tela de Auditoria da clínica (LGPD L-14)
 *
 * Sem busca livre por paciente: esse filtro só chega pela URL (atalho na ficha do
 * paciente), representado por um chip na tela — ver CompanyAudit.js.
 *
 * @param {Object} props
 * @param {Array<string>} props.actions - ações existentes (vindas de audit_log.php)
 * @param {string} props.action
 * @param {Function} props.onActionChange
 * @param {Array<{id, name}>} props.users - usuários existentes na trilha
 * @param {string} props.userId
 * @param {Function} props.onUserChange
 * @param {string} props.dateFrom
 * @param {Function} props.onDateFromChange
 * @param {string} props.dateTo
 * @param {Function} props.onDateToChange
 */
function CompanyAuditFilters({
  actions = [],
  action,
  onActionChange,
  users = [],
  userId,
  onUserChange,
  dateFrom,
  onDateFromChange,
  dateTo,
  onDateToChange,
}) {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        borderBottom: '1px solid #E8ECF0',
        bgcolor: '#fff',
      }}
    >
      <Select size="small" value={action || ''} onChange={(e) => onActionChange(e.target.value)} sx={selectSx}>
        <MenuItem value="">Todas as ações</MenuItem>
        {actions.map((a) => (
          <MenuItem key={a} value={a}>{AUDIT_ACTION_LABELS[a] || a}</MenuItem>
        ))}
      </Select>

      <Select size="small" value={userId || ''} onChange={(e) => onUserChange(e.target.value)} sx={selectSx}>
        <MenuItem value="">Todos os usuários</MenuItem>
        {users.map((u) => (
          <MenuItem key={u.id} value={u.id}>{u.name}</MenuItem>
        ))}
      </Select>

      <TextField
        size="small"
        type="date"
        label="De"
        InputLabelProps={{ shrink: true }}
        value={dateFrom}
        onChange={(e) => onDateFromChange(e.target.value)}
        sx={{ width: 160, ...textSx }}
      />

      <TextField
        size="small"
        type="date"
        label="Até"
        InputLabelProps={{ shrink: true }}
        value={dateTo}
        onChange={(e) => onDateToChange(e.target.value)}
        sx={{ width: 160, ...textSx }}
      />
    </Box>
  );
}

export default CompanyAuditFilters;
